import Content from '../types/enums/content';

interface Params {
  image: string;
  title: string;
  action: (node?: number | null) => void;
}

class Setting {
  image: string;
  title: string;
  type: Content;
  action: (node?: number | null) => void;

  constructor({ action, image, title }: Params) {
    this.image = image;
    this.title = title;
    this.type = Content.SETTING;
    this.action = action;
  }
}

export default Setting;
